import { h, FunctionComponent } from 'preact';
import './wcag-summary-skeleton.scss';
import { IssueType } from 'constants/violations';
import { COMPONENT_NAME_WCAG_SUMMARY_SKELETON } from './constants';

export const WCAGSummarySkeleton: FunctionComponent = () => (
  <div className="uwaw-wcag-summary" data-testid={COMPONENT_NAME_WCAG_SUMMARY_SKELETON}>
    <div className="uwaw-wcag-summary-skeleton__top">
      <div className="uwaw-wcag-summary-skeleton__label-container">
        <div className="uwaw-wcag-summary-skeleton__label" />
        <div className="uwaw-wcag-summary-skeleton__label" />
      </div>
      <div className="uwaw-wcag-summary-skeleton__button" />
    </div>

    <div className="uwaw-wcag-summary-skeleton__bottom">
      <div className="uwaw-wcag-summary-skeleton__chart">
        <div className="uwaw-wcag-summary-skeleton__chart-label" />

        <img role="none" alt="" src="./frontend/images/violations-chart-skeleton.svg" />
      </div>

      {Object.values(IssueType).map(() => (
        <div className="uwaw-wcag-summary-skeleton__stat">
          <div className="uwaw-wcag-summary-skeleton__stat-count" />
          <div className="uwaw-wcag-summary-skeleton__stat-type" />
        </div>
      ))}
    </div>
  </div>
);

WCAGSummarySkeleton.displayName = COMPONENT_NAME_WCAG_SUMMARY_SKELETON;
